import React, { useCallback, useEffect, useState } from "react";
import PaymentMethod from "../components/sections/PaymentMethod";
import OrderSummary from "../components/sections/OrderSummary";
import ShippingAddress from "../components/sections/ShippingAddress";
import DetailsBreadcrumb from "../components/Items/DetailsBreadcrumb";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { loginModalOpen } from "../redux/slice/loginSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  addWishlistProduct,
  confirmPaymentOrder,
  newPlaseOrder,
} from "../services/frontService/ProductService";
import { setCartDetails } from "../redux/slice/cartSlice";
import HelcimPayIframe from "../components/elements/HelcimPayIframe";

const items = [
  { label: "Home", href: "/" },
  { label: "Shipping Address", href: "/checkout" },
];

const PaymentInformation = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = location;
  const myCheckoutData = useSelector((state) => state?.checkout?.checkoutData);
  const isLogin = useSelector((state) => state?.auth?.isLogin);
  const [loaded, setLoaded] = useState(false);
  const myCartList = useSelector(
    (state) => state?.cart?.cartListData?.cartList
  );

  const orderSummary = myCheckoutData ? myCheckoutData?.orderSummary : {};
  const TOKEN_LENGTH = 22;

  const [checkoutToken, setCheckoutToken] = useState(null);

  const paymentConfirm = async (data) => {
    if (isLogin) {
      setLoaded(true);
      try {
        const res = await confirmPaymentOrder({ data });

        if (res?.data?.status === 200 || res?.data?.status === 201) {
          toast.info(res?.data?.message);
          navigate("/user-orders");
          dispatch(setCartDetails(res?.data));
        } else {
          toast.info(
            res?.data?.message || res?.data?.errors || "Something went wrong"
          );
        }

        setLoaded(false);
      } catch (err) {
        setLoaded(false);
        toast.error("Somthing went wrong !!!");
      }
    } else {
      dispatch(loginModalOpen({ isOpen: true }));
    }
  };

  const handleHelcimPayResponse = useCallback(
    (event) => {
      const helcimPayJsIdentifierKey = "helcim-pay-js-" + checkoutToken;

      if (event.data?.eventName === helcimPayJsIdentifierKey) {
        if (event.data.eventStatus === "ABORTED") {
          toast.error("Transaction failed: " + event.data.eventMessage);
          setCheckoutToken(null);
        }

        if (event.data.eventStatus === "SUCCESS") {
          try {
            const parsed = JSON.parse(event.data.eventMessage);
            const jsonString = JSON.stringify(parsed, null, 2);
            paymentConfirm(jsonString);
          } catch (err) {
            console.error("Error parsing payment response:", err);
          }
        }
      }
    },
    [checkoutToken, paymentConfirm]
  );

  useEffect(() => {
    if (!checkoutToken) return;

    window.addEventListener("message", handleHelcimPayResponse);

    return () => {
      window.removeEventListener("message", handleHelcimPayResponse);
    };
  }, [checkoutToken, handleHelcimPayResponse]);

  const onPlaceOrder = async () => {
    if (!orderSummary?.placeOrder) {
      toast.error(
        `Minimum order size should be ${orderSummary?.minimumOrderSize} or more.`
      );
      return;
    }

    if (!isLogin) {
      dispatch(loginModalOpen({ isOpen: true }));
      return;
    }

    setLoaded(true);

    try {
      const res = await newPlaseOrder({
        shippingLocation: state?.shippingAddress?.location,
        shippingState: state?.shippingAddress?.state,
        shippingCity: state?.shippingAddress?.city,
        shippingPin: state?.shippingAddress?.pin,
        billingAddress:
          state?.billingAddress?.address || state?.billingAddress?.location,
        billingAddress2: state?.billingAddress?.address2 || null,
        billingState: state?.billingAddress?.state,
        billingCity: state?.billingAddress?.city,
        billingPin: state?.billingAddress?.pin,
        name: state?.contactDetails?.name,
        email: state?.contactDetails?.email,
        phone: state?.contactDetails?.phone,
      });

      const status = res?.data?.status;
      const paymentData = res?.data?.data;

      if (status === 200 || status === 201) {
        // dispatch(setCartDetails(res?.data));
        setCheckoutToken(paymentData?.checkoutToken); // ⬅️ triggers iframe
      } else {
        toast.info(
          res?.data?.message || res?.data?.errors || "Something went wrong"
        );
      }
    } catch (err) {
      toast.error("Something went wrong!");
    } finally {
      setLoaded(false);
    }
  };

  return (
    <>
      <div className="relativew-full sm:px-0 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto xl:mt-40 md:mt-32 mt-20">
        {/* <div className="pb-5 md:mx-0 mx-5">
          <DetailsBreadcrumb items={items} />
        </div> */}
        <div className=" xl:flex block ">
          <PaymentMethod
            onPlaceOrder={onPlaceOrder}
            loaded={loaded}
            setLoaded={setLoaded}
            myCartList={myCartList}
            myCheckoutData={myCheckoutData}
            data={state}
          />
          <OrderSummary myCheckoutData={myCheckoutData} />
        </div>
      </div>
      {checkoutToken && (
        <HelcimPayIframe
          token={checkoutToken}
          phone={state?.contactDetails?.phone}
          email={state?.contactDetails?.email}
          csrf="yourCSRFTokenHere"
          onClose={() => setCheckoutToken(null)}
        />
      )}
    </>
  );
};

export default PaymentInformation;
